
window.Shopify.formatMoney2 = function(cents, format) {
	if (typeof cents == 'string') { cents = cents.replace('.',''); }
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal   = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) { return 0; }

		number = (number/100.0).toFixed(precision);

		var parts   = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents   = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch(formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

$('body').magnificPopup({
	delegate: '.js-popup-1__trigger',
	type: 'inline',
	midClick: true
});

$('body').on('click', '.js-global__scroll-to-section', function(event) {
	const $target = $(document).find(`[data-scroll-id="${$(this).attr('data-scroll-to')}"]`);

	if( $target.length ) {
		event.preventDefault();
		$('html, body').animate({
			scrollTop: $target.offset().top
		}, 500);
	}
})

class ComponentCategoryGrid extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			categoryButton: '.js-category-grid__category-button',
			gridItem: '.js-category-grid__item'
		}
		this.cssClass = {
			categoryButtonSelected: 'is-active',
			gridItemHidden: 'is-hidden'
		}
	}

	connectedCallback() {

		// filter items initially
		(() => {
			const $categoryButtons = $(this).find(this.selectors.categoryButton);
			if ($categoryButtons.length < 1) return;

			const $activeCategoryButton = $categoryButtons.filter((i, button) => $(button).hasClass(this.cssClass.categoryButtonSelected));
			const categoryId = $activeCategoryButton.length > 0 ? $activeCategoryButton.attr('data-category') : $categoryButtons.first().attr('data-category');

			this.filterItemsByCategory(categoryId);
		})();

		// filter on category button click
		{
			const _this = this;
			$(this).on('click', this.selectors.categoryButton, function() {
				_this.filterItemsByCategory($(this).attr('data-category'));
			})
		}
	}

	filterItemsByCategory(categoryId) {
		const $categoryButtons = $(this).find(this.selectors.categoryButton);
		const $gridItems = $(this).find(this.selectors.gridItem);
		const $targetCategoryButton = $categoryButtons.filter(`[data-category="${categoryId}"]`);

		if ($targetCategoryButton.hasClass(this.cssClass.categoryButtonSelected)) {
			return;
		}

		// toggle active category button
		$categoryButtons.removeClass(this.cssClass.categoryButtonSelected);
		$targetCategoryButton.addClass(this.cssClass.categoryButtonSelected);

		// toggle grid items
		$gridItems.removeClass(this.cssClass.gridItemHidden);
		$gridItems.filter((i, item) => $(item).attr('data-category') !== categoryId).addClass(this.cssClass.gridItemHidden);

		// trigger event
		$(this).trigger('categoryFiltered', categoryId);
	}
}
customElements.define('c-category-grid', ComponentCategoryGrid);

class ComponentCategoryGrid2 extends ComponentCategoryGrid {
	constructor() {
		super();

		this.selectors = {
			...this.selectors,
			itemDescription: '.js-category-grid-2__item-description'
		}
		this.cssClass = {
			...this.cssClass,
			gridItemSelected: 'is-selected',
			itemDescriptionVisible: 'is-active'
		}
	}

	connectedCallback() {

		// show description for the first active grid item after a category has been selected
		$(this).on('categoryFiltered', e => {
			const $visibleGridItems = $(this).find(this.selectors.gridItem).filter((i, item) => !$(item).hasClass(this.cssClass.gridItemHidden));
			const gridItemId = $visibleGridItems.first().attr('data-grid-item');

			this.showItemDescription(gridItemId);
		});

		super.connectedCallback();

		// toggle description by click on a grid item
		{
			const _this = this;
			$(this).on('click', this.selectors.gridItem, function() {
				_this.showItemDescription($(this).attr('data-grid-item'));
			})
		}
	}

	showItemDescription(gridItemId) {
		const $itemDescriptions = $(this).find(this.selectors.itemDescription);
		const $visibleGridItems = $(this).find(this.selectors.gridItem).filter((i, item) => !$(item).hasClass(this.cssClass.gridItemHidden));
		const $targetGridItem = $visibleGridItems.filter((i, item) => $(item).attr('data-grid-item') === gridItemId);

		if ($targetGridItem.hasClass(this.cssClass.gridItemSelected)) {
			return;
		}

		// toggle active grid item
		$visibleGridItems.removeClass(this.cssClass.gridItemSelected);
		$targetGridItem.addClass(this.cssClass.gridItemSelected);

		// toggle grid item description
		$itemDescriptions.removeClass(this.cssClass.itemDescriptionVisible);
		$itemDescriptions.filter((i, desc) => $(desc).attr('data-grid-item') === gridItemId).addClass(this.cssClass.itemDescriptionVisible);

		// trigger event
		$(this).trigger('itemDescriptionToggled', gridItemId);
	}
}
customElements.define('c-category-grid-2', ComponentCategoryGrid2);

class ComponentSliderText extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			slider: '.js-slider-text__swiper-slider',
			sliderPrevButton: '.js-slider-text__slider-prev-button',
			sliderNextButton: '.js-slider-text__slider-next-button',
			sliderScrollbar: '.js-slider-text__slider-scrollbar',
			drawAdditionalTitle: '.js-slider-text__draw-additional-title',
			drawSliderSide: '.js-slider-text__draw-slider-side'
		}
		this.linesArr = [];
	}

	connectedCallback() {
		this._initSlider();

		this._createLines(true);

		{
			let lineTriggerElements = this.linesArr.map(lineObj => lineObj.triggerElement);
			lineTriggerElements = $.uniqueSort(lineTriggerElements);

			lineTriggerElements.forEach((element, i) => {
				document.addEventListener('scroll', AnimEvent.add(() => {
					const [isInViewport, isAboveViewport] = this._getElementViewport(element);
					if (isInViewport) {
						this._animateElementLines(element, 'show');
					} else if (!isAboveViewport) {
						this._animateElementLines(element, 'hide');
					}
				}), false);
			})
		}
	}

	_initSlider() {
		this.slider = new Swiper(this.selectors.slider, {
			speed: 400,
			spaceBetween: 50,
			slidesPerView: 'auto',
			navigation: {
				nextEl: this.selectors.sliderNextButton,
				prevEl: this.selectors.sliderPrevButton,
			},
			scrollbar: {
				el: this.selectors.sliderScrollbar,
				draggable: true,
			}
		});
	}

	_createLines(isHideInitially) {
		const optionsDefault = {
			color: '#FFFFFF',
			size: 3,
			endPlug: 'behind',
			dash: {
				len: 3,
				gap: 7
			},
			path: 'fluid',
			hide: isHideInitially || false
		}

		// line from additional title to slider side
		{
			let line = new LeaderLine(
				LeaderLine.areaAnchor(this.querySelector(this.selectors.drawAdditionalTitle), {
					x: '0%',
					y: '10%',
					width: '100%',
					height: '80%',
					radius: 40,
					dash: {
						len: 3,
						gap: 7
					}
				}),
				LeaderLine.pointAnchor(this.querySelector(this.selectors.drawSliderSide), {x: -20, y: '50%'}),
				{
					...optionsDefault,
					startSocket: 'right',
					endSocket: 'left'
				}
			);
			this.linesArr.push({
				triggerElement: this.querySelector(this.selectors.drawSliderSide),
				line: line
			});
		}
	}

	/**
	 * @param {HTMLElement} element
	 * @param {('show'|'hide')} action
	 * */
	_animateElementLines(element, action = 'show') {
		this.linesArr.map(lineObj => {
			if (lineObj.triggerElement.isEqualNode(element)) {

				lineObj.repositionLineEvent = AnimEvent.add(function() {
					lineObj.line.position();
				});

				if (action === 'show') {
					lineObj.line.show('draw');
					document.addEventListener('scroll', lineObj.repositionLineEvent);
				} else if (action === 'hide') {
					lineObj.line.hide('draw');
					document.removeEventListener('scroll', lineObj.repositionLineEvent);
				}
			}
		});
	}

	/**
	 * @param {HTMLElement} el
	 * @return {Array.<[isInViewport: boolean, isAboveViewport: boolean]>}
	 * */
	_getElementViewport(el) {
		const rect = el.getBoundingClientRect();
		return [
			(
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			),
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
		];
	}
}
customElements.define('c-slider-text', ComponentSliderText);

class ComponentStarterPack extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			step: '.js-starter-pack__step',
			optionRadio: '.js-starter-pack__option-radio',
			optionRadioInput: '.js-starter-pack__option-radio-input',
			imageGoal: '.js-starter-pack__image-goal', // content for image side based on goal
			submitButton: '.js-starter-pack__submit-button',
			subscriptionInfo: '.js-starter-pack__subscription-info',
			subscriptionInfoTemplate: '.t-starter-pack__subscription-info',
			selectInput: '.js-starter-pack__select-input',
			selectGoalInput: '.js-starter-pack__goal',
			priceTotalSubscription: '.js-starter-pack__price-total-subscription',
			priceTotalOnetime: '.js-starter-pack__price-total-onetime'
		};
		this.cssClass = {
			stepCompleted: 'is-completed',
			optionRadioSelected: 'is-selected',
			imageGoalVisible: 'is-active',
			priceHidden: 'is-hidden',
			subscriptionInfoHidden: 'is-subscription-info-hidden',
			stepError: 'is-error',
			selectInputMobile: 'js-starter-pack__select-input--mobile-only'
		};
	}

	connectedCallback() {

		// initial select option radio
		$(this).find(this.selectors.optionRadioInput).each((i, optionInput) => {

			if ($(optionInput).is(':checked')) {
				this.selectOptionRadio($(optionInput).attr('id'));
			}
		});

		// initial select option select input
		$(this).find(this.selectors.selectInput).each((i, select) => {
			if (!!$(select).val()) {
				this.selectOptionSelect($(select).attr('id'));
			}
		})

		// select option by click
		{
			const _this = this;
			$(this).on('change', this.selectors.optionRadioInput, function() {
				_this.selectOptionRadio($(this).attr('id'));
			})
		}

		// select option in select by click
		{
			const _this = this;
			$(this).on('change', this.selectors.selectInput, function() {
				_this.selectOptionSelect($(this).attr('id'));
			})
		}

		// submit form on submit button click
		{
			$(this).on('click', this.selectors.submitButton, this.submitForm.bind(this));
		}

		// select goal based on search params in URL
		{
			const urlParams = new URLSearchParams(window.location.search);
			const goal = urlParams.get('goal');

			if (goal) {
				const $option = $(this).find(this.selectors.optionRadioInput).filter(`[name="goal"][value="${goal}"]`);
				if ($option){
					$option.prop('checked', true).change();

					setTimeout(function (){
						$('.js-starter-pack__goal').val(`${goal}`);
					},500)
				}


			}
		}
	}

	selectOptionRadio(optionInputId) {
		const $optionInput = $(this).find(this.selectors.optionRadioInput).filter(`#${optionInputId}`);
		const $option = $optionInput.parents(this.selectors.optionRadio);
		const $step = $optionInput.parents(this.selectors.step);

		if ($option.hasClass(this.cssClass.optionRadioSelected)) return;

		// toggle selected class for the options within current step
		$step.find(this.selectors.optionRadio).removeClass(this.cssClass.optionRadioSelected);
		$optionInput.parents(this.selectors.optionRadio).addClass(this.cssClass.optionRadioSelected);

		// toggle image goal (content for image side based on goal)
		if ($optionInput.attr('name') === 'goal') {
			this._showImageGoal(optionInputId);
		}

		// two-way binding with select on mobile
		{
			const name = $optionInput.attr('name');
			const value = $optionInput.val();
			const $mobileSelectInput = $step.find(this.selectors.selectInput).filter(`.${this.cssClass.selectInputMobile}[name="${name}"]`).eq(0);
			if ($mobileSelectInput.length > 0 && $mobileSelectInput.val() !== value) {
				$mobileSelectInput.val(value).change();
			}
		}

		this._updateForm($step);
	}

	selectOptionSelect(selectInputId) {
		const $select = $(this).find(this.selectors.selectInput).filter(`#${selectInputId}`);
		const $step = $select.parents(this.selectors.step);

		// two-way binding with radio options on desktop
		{
			if ($select.hasClass(this.cssClass.selectInputMobile)) {
				const name = $select.attr('name');
				const value = $select.val();
				const $optionSelect = $step.find(this.selectors.optionRadioInput).filter(`[name="${name}"][value="${value}"]`).eq(0);

				if ($optionSelect.length > 0 && $optionSelect.not(':checked')) {
					$optionSelect.prop('checked', true).change();
				}
			}
		}

		this._updateForm($step);
	}

	markStepError($step) {
		$step.removeClass(this.cssClass.stepCompleted);
		$step.addClass(this.cssClass.stepError);
	}

	markStepCompleted($step) {
		$step.removeClass(this.cssClass.stepError);
		$step.addClass(this.cssClass.stepCompleted);
	}

	_showImageGoal(goalId) {
		const $imageGoals = $(this).find(this.selectors.imageGoal);

		$imageGoals.removeClass(this.cssClass.imageGoalVisible);
		$imageGoals.filter(`[data-goal-id="${goalId}"]`).addClass(this.cssClass.imageGoalVisible);
	}

	_generateRandomHash(length) {
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let hash = '';
		for (let i = 0; i < length; i++) {
			hash += characters.charAt(Math.floor(Math.random() * characters.length));
		}
		return hash;
	}

	async submitForm() {
		const goal = $(this).find('input[name="goal"]:checked').val();
		const flavour = $(this).find('input[name="flavour"]:checked').val();
		const freeTshirt = $(this).find('select[name="free-t-shirt"]').val();
		const paymentType = $(this).find('input[name="payment-type"]:checked').val();

		// validate form
		if (!goal) {
			this.markStepError($(this).find(this.selectors.step).filter('[data-step-id="goal"]'));
			return;
		} else if (!flavour) {
			this.markStepError($(this).find(this.selectors.step).filter('[data-step-id="flavour"]'));
			return;
		} else if (!freeTshirt) {
			this.markStepError($(this).find(this.selectors.step).filter('[data-step-id="free-t-shirt"]'));
			return;
		} else if (!paymentType) {
			this.markStepError($(this).find(this.selectors.step).filter('[data-step-id="payment-type"]'));
			return;
		}

		// disable submit button
		$(this).find(this.selectors.submitButton).attr('disabled', 'disabled');

		const paymentTypeKey = paymentType === 'subscribe' ? 'subscription' : 'onetime';

		// define variables
		let items = [
			// add free t-shirt
			{
				id: +$(this).find('select[name="free-t-shirt"] option:selected').attr('data-cart').split(':')[0],
				properties: {
					"_is_subscription": paymentType === 'subscribe' ? "1" : "0",
					"_fp": "1",
					"_mw_grouped_product_relation_6748735799379": "BUN-START062", // here is the id of the starter pack product
					"_bundle_image": "//cdn.shopify.com/s/files/1/0066/2359/2499/products/1.StarterPackHero_withT-Shirt-min_small.jpg?v=1657031260",
					"_bundle_sku": paymentTypeKey === 'subscription' ? "BUN-START062_REGULAR" : 'BUN-START062',
					"_bundle_product": "NGX PRO Starter Pack",
					"_bundle_handle": "ngx-starter-pack",
					"_bundle_goal":goal,
					"_cartlink": $(this).find('[name="free-t-shirt"] option:selected').attr('data-cart').split(':')[1],
					"_single_subscription": "0",
					"_pid": "6782674337962",
				}
			},
		];

		// add goal products
		$(this).find('input[name="goal"]:checked').attr(`data-cart-${paymentTypeKey}`).split(',').forEach(product => {
			const product_arr = product.split(':');

			let itemObj = {
				id: product_arr[0],
				properties: {
					"_is_subscription": paymentType === 'subscribe' ? "1" : "0",
					"_fp": "1",
					"_mw_grouped_product_relation_6748735799379": "BUN-START062", // here is the id of the starter pack product
					"_bundle_image": "//cdn.shopify.com/s/files/1/0066/2359/2499/products/1.StarterPackHero_withT-Shirt-min_small.jpg?v=1657031260",
					"_bundle_sku": paymentTypeKey === 'subscription' ? "BUN-START062_REGULAR" : 'BUN-START062',
					"_bundle_product": "NGX PRO Starter Pack",
					"_bundle_handle": "ngx-starter-pack",
					"_bundle_goal":goal,
					"_cartlink": product_arr[1],

				}
			}

			if (paymentType === 'subscribe' && product_arr[2] === 'true') {
				itemObj.properties["shipping_interval_frequency"] = "4";
				itemObj.properties["shipping_interval_unit_type"] = "Weeks";
				itemObj["selling_plan"] = product_arr[3];
			}

			items.push(itemObj);
		});

		// add flavour products
		$(this).find('input[name="flavour"]:checked').attr(`data-cart-${paymentTypeKey}`).split(',').forEach(product => {
			const product_arr = product.split(':');

			let itemObj = {
				id: product_arr[0],
				properties: {
					"_is_subscription": paymentType === 'subscribe' ? "1" : "0",
					"_fp": "1",
					"_mw_grouped_product_relation_6748735799379": "BUN-START062", // here is the id of the starter pack product
					"_bundle_image": "//cdn.shopify.com/s/files/1/0066/2359/2499/products/1.StarterPackHero_withT-Shirt-min_small.jpg?v=1657031260",
					"_bundle_sku": paymentTypeKey === 'subscription' ? "BUN-START062_REGULAR" : 'BUN-START062',
					"_bundle_product": "NGX PRO Starter Pack",
					"_bundle_handle": "ngx-starter-pack",
					"_bundle_goal":goal,
					"_cartlink": product_arr[1]
				},
				'selling_plan': product_arr[2]
			}

			if (paymentType === 'subscribe') {
				const sellingPlanId = $(this).find('input[name="flavour"]:checked').attr('data-cart-selling-plan')?.split(':')[0];
				itemObj.properties["shipping_interval_frequency"] = "4";
				itemObj.properties["shipping_interval_unit_type"] = "Weeks";
			}

			items.push(itemObj);
		});

		// add base products
		$(this).find('input[name="payment-type"]:checked').attr('data-cart').split(',').forEach(product => {
			const product_arr = product.split(':');
			const hash = this._generateRandomHash(5);

			let itemObj = {
				id: product_arr[0],
				properties: {
					"_is_subscription": paymentType === 'subscribe' ? "1" : "0",
					"_fp": "1",
					"_mw_grouped_product_relation_6748735799379": "BUN-START062", // here is the id of the starter pack product
					"_bundle_image": "//cdn.shopify.com/s/files/1/0066/2359/2499/products/1.StarterPackHero_withT-Shirt-min_small.jpg?v=1657031260",
					"_bundle_sku": paymentTypeKey === 'subscription' ? "BUN-START062_REGULAR" : 'BUN-START062',
					"_bundle_product": "NGX PRO Starter Pack",
					"_bundle_handle": "ngx-starter-pack",
					"_bundle_goal":goal,
					"_cartlink": product_arr[1],
					"_hash": hash,
				}
			}

			if (paymentType === 'subscribe') {
				const sellingPlanId = $(this).find('input[name="payment-type"]:checked').attr('data-cart-selling-plan')?.split(':')[0];
				itemObj['selling_plan'] = sellingPlanId;

				itemObj.properties["shipping_interval_frequency"] = "4";
				itemObj.properties["shipping_interval_unit_type"] = "Weeks";
			}

			items = items.map((item) => ({
				...item,
				properties: {
					...item.properties,
					'_parent_hash': hash
				}
			}));

			items.push(itemObj);
		});

		console.log(items);

		// send request
		const _this = this;
		$.ajax({
			type: 'POST',
			url: `${window.Shopify.routes.root}cart/add.js`,
			data: {items: items},
			dataType: 'json',
			success: function(data, textStatus, jqXHR) {
				window.location.pathname = Shopify.routes.root+'cart';
			},
			complete: function(jqXHR, textStatus) {
				$(_this).find(_this.selectors.submitButton).removeAttr('disabled');
			}
		});
	}

	getPrices() {
		const goalPriceSubscription = +$(this).find('input[name="goal"]:checked').attr('data-price-subscription') || +$(this).find('input[name="goal"]').eq(3).attr('data-price-subscription') || 0;
		const goalPriceOnetime = +$(this).find('input[name="goal"]:checked').attr('data-price-onetime') || +$(this).find('input[name="goal"]').eq(3).attr('data-price-onetime') || 0;
		const flavourPriceSubscription = +$(this).find('input[name="flavour"]:checked').attr('data-price-subscription') || +$(this).find('input[name="flavour"]').eq(0).attr('data-price-subscription') || 0;
		const flavourPriceOnetime = +$(this).find('input[name="flavour"]:checked').attr('data-price-onetime') || +$(this).find('input[name="flavour"]').eq(0).attr('data-price-onetime') || 0;

		const addonsPriceSubscription = +$(this).find('input[name="goal"]:checked').attr('data-addon-price-subscription') || 0;
		const addonsPriceOnetime = +$(this).find('input[name="goal"]:checked').attr('data-addon-price-onetime')  || 0;

		const basePriceSubscription = +$(this).find('input[name="payment-type"][value="subscribe"]').attr('data-price') || 0;
		const basePriceOnetime = +$(this).find('input[name="payment-type"][value="one-time"]').attr('data-price') || 0;

		const totalPriceSubscription = goalPriceSubscription + flavourPriceSubscription + basePriceSubscription;
		const totalPriceOnetime = goalPriceOnetime + flavourPriceOnetime + basePriceOnetime;
		const recurringPaymentSubscription = flavourPriceSubscription + basePriceSubscription+addonsPriceSubscription;
		const recurringPaymentOnetime = flavourPriceOnetime + basePriceOnetime+addonsPriceOnetime;
		return [totalPriceSubscription, totalPriceOnetime, recurringPaymentSubscription, recurringPaymentOnetime];
	}

	_updateForm($updatedStep) {
		this._updatePrices();
		this._updateSubscriptionInfo();
		this.markStepCompleted($updatedStep);
	}

	_updateSubscriptionInfo() {
		const paymentType = $(this).find('[name="payment-type"]:checked').val();
		if (paymentType === 'subscribe') {
			const [ , , recurringPaymentSubscription, recurringPaymentOnetime] = this.getPrices();

			$(this).find(this.selectors.subscriptionInfo).html(() => {
				return $(this).find(this.selectors.subscriptionInfoTemplate).html().toString()
					.replace('$price_after$', window.Shopify.formatMoney2(recurringPaymentSubscription, window.spratlyThemeSettings.money_format))
					.replace('$price_before$', window.Shopify.formatMoney2(recurringPaymentOnetime, window.spratlyThemeSettings.money_format))
					.replace('$price_difference$', window.Shopify.formatMoney2(recurringPaymentOnetime - recurringPaymentSubscription, window.spratlyThemeSettings.money_format));
			});
			$(this).find(this.selectors.subscriptionInfo).removeClass(this.cssClass.subscriptionInfoHidden);
		} else {
			$(this).find(this.selectors.subscriptionInfo).addClass(this.cssClass.subscriptionInfoHidden);
		}
	}

	_updatePrices() {
		const [totalPriceSubscription, totalPriceOnetime] = this.getPrices();

		$(this).find(this.selectors.priceTotalSubscription).text(window.Shopify.formatMoney2(totalPriceSubscription, window.spratlyThemeSettings.money_format));
		$(this).find(this.selectors.priceTotalOnetime).text(window.Shopify.formatMoney2(totalPriceOnetime, window.spratlyThemeSettings.money_format));
	}
}
customElements.define('c-starter-pack', ComponentStarterPack);

class ComponentHorizontalList extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			sectionSettings: '.js-horizontal-list__section-settings',
			slider: '.js-horizontal-list__swiper-slider'
		}
	}

	connectedCallback() {
		this.sectionSettings = JSON.parse($(this).find(this.selectors.sectionSettings).text());

		this._initSlider();
	}

	_initSlider() {
		this.slider = new Swiper(this.selectors.slider, {
			speed: 400,
			spaceBetween: 80,
			slidesPerView: 'auto',
			autoplay: this.sectionSettings.is_enable_autoplay ? {
				delay: this.sectionSettings.autoplay_delay
			} : false,
			mousewheel: true,
			freeMode: true,
			centerInsufficientSlides: true,
			rewind: true,
			slidesOffsetBefore: 30,
			slidesOffsetAfter: 30,
			breakpoints: {
				1025: {
					slidesOffsetBefore: 80,
					slidesOffsetAfter: 80
				}
			}
		});
	}
}
customElements.define('c-horizontal-list', ComponentHorizontalList);

class ComponentSteps extends HTMLElement {
	constructor() {
		super();

		this.selectors = {}
		this.cssClass = {
			stepImageFirst: 'is-image-first',
			stepTextFirst: 'is-text-first'
		}
		this.linesArr = [];
	}

	connectedCallback() {
		// this._createLines(true);

		this._initGSAP();
	}

	/**
	 * @param {HTMLElement} element
	 * @param {('show'|'hide')} action
	 * */
	_animateElementLines(element, action = 'show') {
		this.linesArr.map(lineObj => {
			if (lineObj.triggerElement.isEqualNode(element)) {

				lineObj.repositionLineEvent = AnimEvent.add(function() {
					lineObj.line.position();
				});

				if (action === 'show') {
					lineObj.line.show('draw');
					// document.addEventListener('scroll', lineObj.repositionLineEvent);
				} else if (action === 'hide') {
					lineObj.line.hide('draw');
					// document.removeEventListener('scroll', lineObj.repositionLineEvent);
				}
			}
		});
	}

	/**
	 * @param {HTMLElement} el
	 * @return {Array.<[isInViewport: boolean, isAboveViewport: boolean]>}
	 * */
	_getElementViewport(el) {
		const rect = el.getBoundingClientRect();
		return [
			(
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			),
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
		];
	}

	_initGSAP() {

		// icon-man-woman
		{
			const svg = this.querySelector('#icon-man-woman');
			if (svg) {
				gsap.set(svg.querySelectorAll('.fill-mask'), {y: '0%'});
				gsap.from(svg.querySelectorAll('.fill-mask'), {
					scrollTrigger: {
						trigger: svg,
						start: 'top 85%',
						end: 'top 20%',
						// markers: true,
						scrub: true
					},
					y: '80%'
				});
			}
		}

		// icon-genes
		{
			const svg = this.querySelector('#icon-genes');
			if (svg) {
				gsap.from(svg.querySelectorAll('g'), {
					scrollTrigger: {
						trigger: svg,
						start: 'top 100%',
						end: 'top 20%',
						// markers: true,
						scrub: true
					},
					opacity: 0,
					x: 'random(-50, 50)',
					y: 'random(-50, 50)',
					// duration: 0.5,
					stagger: {
						each: 0.25,
						// repeat: 1,
						// yoyo: true,
						from: 'random',
					}
				});
			}
		}

		// icon-steps
		{
			const svg = this.querySelector('#icon-steps');
			if (svg) {
				const elementsToAnimate = gsap.utils.toArray(svg.querySelectorAll('circle'));
				gsap.from(elementsToAnimate, {
					scrollTrigger: {
						trigger: svg,
						start: 'top 75%',
						end: 'bottom 75%',
						// markers: true,
						scrub: true
					},
					opacity: 0,
					// x: 'random(-50, 50)',
					// y: 'random(-50, 50)',
					duration: 0,
					stagger: {
						each: 0.01,
						// repeat: 1,
						// yoyo: true,
						// from: 'random',
					}
				});
			}
		}
	}
}
customElements.define('c-steps', ComponentSteps);

class ComponentImageText4 extends HTMLElement {

	constructor() {
		super();

		this.selectors = {
			drawSubtitle: '.js-image-text-4__draw-subtitle',
			drawQuoteIcon: '.js-image-text-4__draw-quote-icon',
			drawQuoteText: '.js-image-text-4__draw-quote-text'
		}
		this.cssClass = {}
		this.linesArr = [];
	}

	connectedCallback() {
		this._createLines(true);

		{
			let lineTriggerElements = this.linesArr.map(lineObj => lineObj.triggerElement);
			lineTriggerElements = $.uniqueSort(lineTriggerElements);

			lineTriggerElements.forEach((element, i) => {
				document.addEventListener('scroll', AnimEvent.add(() => {
					const [isInViewport, isAboveViewport] = this._getElementViewport(element);
					if (isInViewport) {
						this._animateElementLines(element, 'show');
					} else if (!isAboveViewport) {
						this._animateElementLines(element, 'hide');
					}
				}), false);
			})
		}
	}

	_createLines(isHideInitially) {
		const optionsDefault = {
			color: $(this).attr('data-line-color'),
			size: 3,
			endPlug: 'behind',
			dash: {
				len: 3,
				gap: 7
			},
			path: 'fluid',
			hide: isHideInitially || false
		}

		// line from subtitle to quote icon
		{
			let line = new LeaderLine(
				this.querySelector(this.selectors.drawSubtitle),
				this.querySelector(this.selectors.drawQuoteIcon),
				{
					...optionsDefault,
					// startSocketGravity: [335, 0],
					// endSocketGravity: [0, -95],
					path: 'grid',
					startSocket: 'right',
					endSocket: 'top'
				}
			);
			this.linesArr.push({
				triggerElement: this.querySelector(this.selectors.drawQuoteText),
				line: line
			});
		}

		// from quote icon to quote text
		{
			let line = new LeaderLine(
				this.querySelector(this.selectors.drawQuoteIcon),
				LeaderLine.areaAnchor(this.querySelector(this.selectors.drawQuoteText), {
					x: '-6%',
					y: '-10%',
					width: '112%',
					height: '120%',
					radius: 40,
					dash: {
						len: 3,
						gap: 7
					}
				}),
				{
					...optionsDefault,
					path: 'straight',
					startSocket: 'bottom',
					endSocket: 'right'
				}
			);
			this.linesArr.push({
				triggerElement: this.querySelector(this.selectors.drawQuoteText),
				line: line
			});
		}
	}

	/**
	 * @param {HTMLElement} element
	 * @param {('show'|'hide')} action
	 * */
	_animateElementLines(element, action = 'show') {
		this.linesArr.map(lineObj => {
			if (lineObj.triggerElement.isEqualNode(element)) {

				lineObj.repositionLineEvent = AnimEvent.add(function() {
					lineObj.line.position();
				});

				if (action === 'show') {
					lineObj.line.show('draw');
					document.addEventListener('scroll', lineObj.repositionLineEvent);
				} else if (action === 'hide') {
					lineObj.line.hide('draw');
					document.removeEventListener('scroll', lineObj.repositionLineEvent);
				}
			}
		});
	}

	/**
	 * @param {HTMLElement} el
	 * @return {Array.<[isInViewport: boolean, isAboveViewport: boolean]>}
	 * */
	_getElementViewport(el) {
		const rect = el.getBoundingClientRect();
		return [
			(
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			),
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
		];
	}
}
customElements.define('c-image-text-4', ComponentImageText4);
